import { ApplicationResolutionService } from '@services/application-resolution.service';
import { Component, DestroyRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { BackButtonService } from '@services/back-button.service';
import { Keyboard } from '@capacitor/keyboard';
import { AuthService } from '@services/auth.service';
import { Subscription } from 'rxjs';
import { PhoneMaskPipe } from '@pipes/phoneMask.pipe';
import { DatePipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ResolutionDirective } from '@directives/resolution.directive';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close, closeOutline, arrowBackOutline, chevronForward, add, eyeOutline, eyeOffOutline } from 'ionicons/icons';
import { SplashScreenService } from '@services/splash-screen.service';
import dayjs from 'dayjs/esm';
import utc from 'dayjs/esm/plugin/utc';
import timezone from 'dayjs/esm/plugin/timezone';
import { InitAppService } from '@services/init-app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [ResolutionDirective, RouterOutlet, IonApp, IonRouterOutlet],
  providers: [PhoneMaskPipe, DatePipe],
})
export class AppComponent implements OnInit, OnDestroy {
  loginSubscription: Subscription;
  logoutSubscription: Subscription;
  @HostListener('window:beforeunload')
  onDestroy() {
    this.initAppService.closeServices();
  }

  constructor(
    private readonly applicationResolutionService: ApplicationResolutionService,
    private readonly backButtonService: BackButtonService,
    private readonly authService: AuthService,
    private readonly splashScreenService: SplashScreenService,
    private readonly initAppService: InitAppService,
    private readonly destroyRef: DestroyRef
  ) {
    addIcons({
      close,
      closeOutline,
      arrowBackOutline,
      chevronForward,
      add,
      eyeOutline,
      eyeOffOutline,
    });
  }

  async ngOnInit() {
    this.calculateVh();
    window.addEventListener('resize', () => this.calculateVh());
    if (this.applicationResolutionService.isApp) {
      this.splashScreenService.hide();
      Keyboard.addListener('keyboardDidHide', () => this.calculateVh());
      this.backButtonService.initBackButtonListener();
    } else {
      this.splashScreenService.init();
    }
    this.authService.onLogIn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.initAppService.initServices());
    this.authService.onLogOut.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.initAppService.closeServices(true));
  }

  ngOnDestroy() {
    this.initAppService.closeServices();
    Keyboard.removeAllListeners();
  }

  calculateVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
